import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { modalTypes } from "constants/types";
import { func } from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import classes from "./CancelAnalysisModal.module.scss";

const CancelAnalysisModal = ({ onConfirm }) => {
  const dispatch = useDispatch();

  const onClickConfirm = () => {
    dispatch(hideModal(modalTypes.CANCEL_ANALYSIS_MODAL));
    if (onConfirm) {
      onConfirm();
    }
  };

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.CANCEL_ANALYSIS_MODAL));
  };

  return (
    <Modal
      data-testid="cancel-analysis-modal"
      className={clsx(classes["cancel_analysis_modal"], "fade-in")}
      show
      onDismiss={onDismiss}
      backdrop
      centered
    >
      <Modal.Header>Cancel Analysis</Modal.Header>

      <Modal.Body>
        <p>Are you sure you want to cancel this job?</p>
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Back
        </NewButton>

        <NewButton
          data-testid="save-button"
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
        >
          Yes, please cancel
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

CancelAnalysisModal.propTypes = {
  onConfirm: func,
};

export default CancelAnalysisModal;
